var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToastSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 46.5,
    r: 46.5,
    fill: "#34A853",
    fillOpacity: 0.11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 30.5C40.0604 21.9396 53.9396 21.9396 62.5 30.5V30.5C71.0604 39.0604 71.0604 52.9396 62.5 61.5V61.5C53.9396 70.0604 40.0604 70.0604 31.5 61.5V61.5C22.9396 52.9396 22.9396 39.0604 31.5 30.5V30.5Z",
    fill: "#1ACE37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7992 49.2008L33.7992 49.2008L40.5492 55.9508C41.2814 56.683 42.4686 56.683 43.2008 55.9508L59.7008 39.4508C60.433 38.7186 60.433 37.5314 59.7008 36.7992C58.9685 36.0669 57.7815 36.0669 57.0492 36.7992L57.0492 36.7992L41.875 51.9733L36.4508 46.5492C36.4508 46.5492 36.4508 46.5492 36.4508 46.5492C35.7186 45.817 34.5314 45.817 33.7992 46.5492C33.0669 47.2815 33.0669 48.4685 33.7992 49.2008Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastSuccessIcon);
export default __webpack_public_path__ + "static/media/toast-success-icon.130c12069885b75e61cc7e830c89cb5a.svg";
export { ForwardRef as ReactComponent };